<template>
    <b-card-code
        title="Add New" 
    >
          <!-- form -->
          <validation-observer
            ref="OrgAddForm"
            #default="{invalid}"      
          >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="addOrg"
          >
                <!-- Name -->
                <b-form-group
                  label="Full Name"
                  label-for="full-name">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="fullname"
                      rules="required">
                        <b-form-input
                          id="fullname"
                          v-model="fullname"
                          :state="errors.length > 0 ? false:null"
                          name="fullname"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <!-- Email -->
                <b-form-group
                  label="Email"
                  label-for="email">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="email"
                      rules="email|required">
                        <b-form-input
                          id="email"
                          v-model="email"
                          :state="errors.length > 0 ? false:null"
                          name="email"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <!-- Password -->
                <b-form-group
                  label="Password"
                  label-for="Password">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="password"
                      rules="required">
                        <b-input-group
                            class="input-group-merge"
                            :class="errors.length > 0 ? 'is-invalid':null"
                        >
                            <b-form-input
                            id="password"
                            v-model="password"
                            :state="errors.length > 0 ? false:null"
                            :type="passwordFieldType"
                            name="password"
                            placeholder="············"
                            />
                            <b-input-group-append is-text>
                                <feather-icon
                                    class="cursor-pointer"
                                    :icon="passwordToggleIcon"
                                    @click="togglePasswordVisibility"
                                />
                            </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <!-- Name -->
                <b-form-group
                  label="Organization Name"
                  label-for="organization-name">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="org_name"
                      rules="required">
                        <b-form-input
                          id="org_name"
                          v-model="org_name"
                          :state="errors.length > 0 ? false:null"
                          name="org_name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group
                  label="Organization Address"
                  label-for="organization-address">
                    
                        <b-form-input
                          id="org_address"
                          v-model="org_address"
                          name="org_address"
                        />
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                </b-form-group>

                <b-form-group
                  label="Organization Nick Name"
                  label-for="organization-nick-name">
                    
                        <b-form-input
                          id="org_nick_name"
                          v-model="org_nick_name"
                          name="org_nick_name"
                        />
                        <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="invalid"
                >
                  Add
                </b-button>
            </b-form>
          </validation-observer>

  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { required } from '@validations'
// import { BTable } from 'bootstrap-vue'
// import { BPagination } from 'bootstrap-vue'

export default {
  components: {
    BCardCode,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BButton,
    BCol, 
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BInputGroup

  },
  data() {
    return {
      fullname:"",
      email: "",
      password:"",
      org_name: "",
      org_address: "",
      org_nick_name: ""
    }
  },
//   created: function () {
//     // this.load();
//   },
  methods: {

    addOrg: function() {
        this.$refs.OrgAddForm.validate().then(success => {
        if (success) {
          //call to axios
          console.log("success")
            let data = {
              fullname: this.fullname,
              email:this.email,
              password:this.password,
              organization_name: this.org_name,
              org_address: this.org_address,
              org_nick_name: this.org_nick_name
            }
            const options = {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              data:data,
              url:  process.env.VUE_APP_BASEURL+'organization/add',
          }
          this.$http(options).then( ( res ) => {
            console.log(res)
            if(res.data.org_id){
               this.$router.push({name: 'Organizations'});
            }
          })
        }  
        })
      }
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  }
}
</script>

